"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validators = void 0;
var final_form_1 = require("final-form");
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+$/;
var Validators = (function () {
    function Validators() {
    }
    Validators.equalTo = function (otherField, languageKey, key) {
        if (languageKey === void 0) { languageKey = ''; }
        if (key === void 0) { key = 'equalto'; }
        return function (value, allValues) {
            var _a;
            var otherValue = final_form_1.getIn(allValues, otherField);
            return value === otherValue
                ? null
                : (_a = {}, _a[key] = { otherField: otherField, languageKey: languageKey }, _a);
        };
    };
    Validators.min = function (min, key) {
        if (key === void 0) { key = 'min'; }
        return function (value) {
            var _a;
            if (_isEmptyInputValue(value) || _isEmptyInputValue(min)) {
                return null;
            }
            var parsedValue = parseFloat(value);
            return !isNaN(parsedValue) && parsedValue < min
                ? (_a = {}, _a[key] = { min: min, actual: value }, _a) : null;
        };
    };
    Validators.max = function (max, key) {
        if (key === void 0) { key = 'max'; }
        return function (value) {
            var _a;
            if (_isEmptyInputValue(value) || _isEmptyInputValue(max)) {
                return null;
            }
            var parsedValue = parseFloat(value);
            return !isNaN(parsedValue) && parsedValue > max
                ? (_a = {}, _a[key] = { max: max, actual: value }, _a) : null;
        };
    };
    Validators.required = function (value) {
        return _isEmptyInputValue(value) ? { required: true } : null;
    };
    Validators.requiredTrue = function (value) {
        return value === true ? null : { required: true };
    };
    Validators.email = function (value) {
        if (_isEmptyInputValue(value)) {
            return null;
        }
        return EMAIL_REGEXP.test(value) ? null : { email: true };
    };
    Validators.minDate = function (minDate, key) {
        if (key === void 0) { key = 'mindate'; }
        var date = new Date(minDate);
        return function (value) {
            var _a;
            if (_isEmptyInputValue(value)) {
                return null;
            }
            var dateValue = new Date(value);
            return dateValue < date
                ? (_a = {}, _a[key] = { requiredDate: minDate, actualDate: value }, _a) : null;
        };
    };
    Validators.maxDate = function (maxDate, key) {
        if (key === void 0) { key = 'maxdate'; }
        var date = new Date(maxDate);
        return function (value) {
            var _a;
            if (_isEmptyInputValue(value)) {
                return null;
            }
            var dateValue = new Date(value);
            return dateValue > date
                ? (_a = {}, _a[key] = { requiredDate: maxDate, actualDate: value }, _a) : null;
        };
    };
    Validators.minLength = function (minLength, key) {
        if (key === void 0) { key = 'minlength'; }
        return function (value) {
            var _a;
            if (_isEmptyInputValue(value)) {
                return null;
            }
            var length = value.length;
            return length < minLength
                ? (_a = {}, _a[key] = { requiredLength: minLength, actualLength: length }, _a) : null;
        };
    };
    Validators.maxLength = function (maxLength, key) {
        if (key === void 0) { key = 'maxlength'; }
        return function (value) {
            var _a;
            if (_isEmptyInputValue(value)) {
                return null;
            }
            var length = value.length;
            return length > maxLength
                ? (_a = {}, _a[key] = { requiredLength: maxLength, actualLength: length }, _a) : null;
        };
    };
    Validators.pattern = function (pattern, key) {
        if (key === void 0) { key = 'pattern'; }
        if (!pattern) {
            return Validators.nullValidator;
        }
        var regex;
        var regexStr;
        if (typeof pattern === 'string') {
            regexStr = '';
            if (pattern.charAt(0) !== '^') {
                regexStr += '^';
            }
            regexStr += pattern;
            if (pattern.charAt(pattern.length - 1) !== '$') {
                regexStr += '$';
            }
            regex = new RegExp(regexStr);
        }
        else {
            regexStr = pattern.toString();
            regex = pattern;
        }
        return function (value) {
            var _a;
            if (_isEmptyInputValue(value)) {
                return null;
            }
            return regex.test("" + value)
                ? null
                : (_a = {}, _a[key] = { requiredPattern: regexStr, actualValue: value }, _a);
        };
    };
    Validators.nullValidator = function () {
        return null;
    };
    Validators.compose = function () {
        var validators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            validators[_i] = arguments[_i];
        }
        var presentValidators = validators.filter(isPresent);
        if (presentValidators.length === 0) {
            return null;
        }
        return function (value, allValues) {
            return _mergeErrors(_executeValidators(value, allValues, presentValidators));
        };
    };
    return Validators;
}());
exports.Validators = Validators;
function _executeValidators(value, allValues, validators) {
    return validators.map(function (v) { return v(value, allValues); });
}
function _isEmptyInputValue(value) {
    return value == null || value.length === 0;
}
function isPresent(o) {
    return o != null;
}
function _mergeErrors(arrayOfErrors) {
    var result = arrayOfErrors.reduce(function (res, errors) {
        return errors != null ? __assign(__assign({}, res), errors) : res;
    }, {});
    return Object.keys(result).length === 0 ? null : result;
}
//# sourceMappingURL=Validators.js.map